import cx from 'classnames';

import styles from './r1-h1.module.scss';

import { quote } from '../../../assets';

export interface R1H1Props {
  children: React.ReactElement;
  color?: string;
  style?: any;
  className?: string;
}

export const R1H1 = (props: R1H1Props) => {
  const { children, color, style = {}, className = '' } = props;
  return (
    <div
      className={cx(styles['R1H1'], color && styles[color], className)}
      style={style}
    >
      <div className="R1H1-img">
        <img src={quote} alt="Quote icon" />
      </div>
      <h1>{children}</h1>
    </div>
  );
};

export default R1H1;
